export default "__VITE_ASSET__Butw7sxI__"